import { NavLink } from "react-router-dom";
import { Icon } from "./Icons";

export default function Header() {
    return (
        <header className="bjnt-header">
            <div className="bjnt-header__top">
                <NavLink to="/" className="bjnt-header__title">
                    <span>De</span>
                    <span>Crop Over</span>
                    <span>Larder</span>
                </NavLink>

                <div className="bjnt-header__partners">
                    <a href="https://bajantube.com" target="_blank">
                        <img
                            src="/wp-content/plugins/bajantube/assets/img/bajantube-icon.png"
                            alt="Bajantube"
                        />
                    </a>
                    <span>x</span>
                    <a href="https://instagram.com/baktuhbim" target="_blank">
                        <img
                            src="/wp-content/plugins/bajantube/assets/img/bak_tuh_bim_logo.png"
                            alt="Bak Tuh Bim"
                        />
                    </a>
                    <span>x</span>
                    <a href="https://instagram.com/rudeboy.barbados" target="_blank">
                        <img
                            src="/wp-content/plugins/bajantube/assets/img/rude_boy_logo_alt.png"
                            alt="Rude Boy Barbados"
                        />
                    </a>
                </div>
            </div>

            <nav className="bjnt-header__nav">
                <NavLink
                    to="/"
                    end
                    className="bjnt-header__icon"
                >
                    <Icon name="home" />
                </NavLink>


                <NavLink to="/discover">
                    Discover
                </NavLink>

                <NavLink to="/charts/trending" end>
                    Trending
                </NavLink>

                <NavLink to="/charts/top-10-season-hits">
                    Top 10
                </NavLink>

                <NavLink className="bjnt-nav-upload" to="/upload">
                    Upload
                </NavLink>

                <NavLink
                    to="/search"
                    className="bjnt-header__icon"
                >
                    <Icon name="search" />
                </NavLink>
            </nav>
        </header>
    );
}